export default ['ru-RU', 'en-US', 'uk-UA']